(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  window.Site = {};

  Site.ThemeView = (function(_super) {
    __extends(ThemeView, _super);

    function ThemeView() {
      return ThemeView.__super__.constructor.apply(this, arguments);
    }

    ThemeView.prototype.el = document.body;

    ThemeView.prototype.initialize = function() {
      var body;
      body = $(document.body);
      this.adminUI = {
        bar: $("#admin_bar_iframe"),
        isExpanded: function() {
          return this.bar.css("left") === "0px";
        }
      };
      this.ltIE9 = $("html").hasClass("lt-ie9");
      this.is404 = body.hasClass("template-404");
      this.ltIE10 = $("html").hasClass("lt-ie10");
      this.isHome = body.hasClass("template-index");
      this.isCart = body.hasClass("template-cart");
      this.isPage = body.hasClass("template-page");
      this.isBlog = body.hasClass("template-blog") || body.hasClass("template-article");
      this.isProduct = body.hasClass("template-product");
      this.isAccount = body.attr("class").indexOf("-customers-") > 0;
      this.hasQuickShop = body.hasClass("quick-shop");
      this.isCollection = body.hasClass("template-collection");
      this.isListCollections = body.hasClass("template-list-collections");
      return this.isAdmin = this.adminUI.bar.length !== -1;
    };

    ThemeView.prototype.render = function() {
      var product, rte, select, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2;
      this.headerView = new Site.HeaderView({
        el: $(".main-header")
      });
      this.sidebarView = new Site.SidebarView({
        el: $(".main-sidebar")
      });
      if (Theme.currencySwitcher) {
        new Site.CurrencyView({
          el: this.$(".currency-switcher")
        });
      }
      if (this.isHome) {
        new Site.HomeView({
          el: this.$el
        });
      }
      if (this.isCollection) {
        new Site.CollectionView({
          el: this.$el
        });
      }
      if (this.isListCollections) {
        new Site.ListCollectionsView({
          el: $(".collections-list")
        });
      }
      if (this.isProduct) {
        new Site.ProductView({
          el: this.$el
        });
      }
      if (this.isCart) {
        new Site.CartView({
          el: this.$el
        });
      }
      if (this.isAccount) {
        new Site.AccountView({
          el: this.$el
        });
      }
      if (this.is404) {
        new Site.NotFoundView({
          el: this.$el
        });
      }
      if (this.hasQuickShop) {
        _ref = $(".product-list-item");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          product = _ref[_i];
          new Site.QuickShopView({
            el: product
          });
        }
      }
      if (this.ltIE10) {
        this.inputPlaceholderFix();
      }
      _ref1 = $(".rte");
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        rte = _ref1[_j];
        new Site.RTEView({
          el: rte
        });
      }
      _ref2 = $("select");
      for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
        select = _ref2[_k];
        new Site.SelectView({
          el: select
        });
      }
      return $(window).on("resize", (function(_this) {
        return function() {
          _this.isMobileWindow = document.documentElement.offsetWidth <= 940;
          return _this.sidebarView.pageResize();
        };
      })(this)).trigger("resize");
    };

    ThemeView.prototype.inputPlaceholderFix = function() {
      var input, placeholders, text, _i, _len;
      placeholders = $("[placeholder]");
      for (_i = 0, _len = placeholders.length; _i < _len; _i++) {
        input = placeholders[_i];
        input = $(input);
        if (!(input.val().length > 0)) {
          text = input.attr("placeholder");
          input.attr("value", text);
          input.data("original-text", text);
        }
      }
      placeholders.focus(function() {
        input = $(this);
        if (input.val() === input.data("original-text")) {
          return input.val("");
        }
      });
      return placeholders.blur(function() {
        input = $(this);
        if (input.val().length === 0) {
          return input.val(input.data("original-text"));
        }
      });
    };

    return ThemeView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.SearchView = (function(_super) {
    __extends(SearchView, _super);

    function SearchView() {
      return SearchView.__super__.constructor.apply(this, arguments);
    }

    SearchView.prototype.events = {
      "focus .search-input": "inputDidFocus",
      "blur .search-input": "inputDidBlur",
      "keyup .search-input": "inputKeyPressed",
      "click .clear-icon": "clearButtonPressed"
    };

    SearchView.prototype.initialize = function() {
      this.input = this.$(".search-input");
      this.liveContainer = this.$(".live-search");
      return this.currentSearchRequest = void 0;
    };

    SearchView.prototype.inputDidFocus = function() {
      return this.$el.addClass("search-active");
    };

    SearchView.prototype.inputDidBlur = function() {
      return this.$el.removeClass("search-active");
    };

    SearchView.prototype.inputKeyPressed = function() {
      var clear, value;
      clear = this.$(".search-clear");
      value = this.input.val();
      if (value.length > 0) {
        this.$el.addClass("clear-active");
        if (value.length > 1) {
          return this.requestLiveSearch(value);
        }
      } else {
        this.$el.removeClass("clear-active");
        this.cancelLiveSearch();
        return this.liveContainer.removeClass("visible").html("");
      }
    };

    SearchView.prototype.clearButtonPressed = function() {
      this.input.val("").focus();
      this.inputKeyPressed();
      return this.liveContainer.removeClass("visible").html("");
    };

    SearchView.prototype.cancelLiveSearch = function() {
      if (this.currentSearchRequest) {
        return this.currentSearchRequest.abort();
      }
    };

    SearchView.prototype.requestLiveSearch = function(query) {
      this.cancelLiveSearch();
      return this.currentSearchRequest = $.ajax({
        url: "/search",
        data: {
          type: "product",
          view: "json",
          q: "*" + query + "*"
        },
        dataType: "json",
        success: (function(_this) {
          return function(data) {
            var item, _i, _len;
            if (data && data.length) {
              _this.liveContainer.html("");
              for (_i = 0, _len = data.length; _i < _len; _i++) {
                item = data[_i];
                _this.liveContainer.append("<a class=\"live-result\" href=\"http://" + Shopify.shop + item.url + "\">\n    <img src=\"" + item.thumb + "\" />\n    <span>\n        " + item.title + "\n        <b>" + item.price + "</b>\n    </span>\n</a>");
              }
              return _this.liveContainer.addClass("visible");
            }
          };
        })(this),
        error: (function(_this) {
          return function() {
            return _this.liveContainer.removeClass("visible");
          };
        })(this)
      });
    };

    return SearchView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.HeaderView = (function(_super) {
    __extends(HeaderView, _super);

    function HeaderView() {
      return HeaderView.__super__.constructor.apply(this, arguments);
    }

    HeaderView.prototype.events = {
      "click .nav-toggle-button": "sidebarWasToggled",
      "click .cart-count": "sidebarWasToggled"
    };

    HeaderView.prototype.initialize = function() {
      return this.searchView = new Site.SearchView({
        el: $(".header-search-form")
      });
    };

    HeaderView.prototype.sidebarWasToggled = function(event) {
      var body, sidebarIsOpen, target;
      body = $(document.body);
      target = $(event.target);
      sidebarIsOpen = !body.hasClass("sidebar-closed");
      if (target.is(".nav-toggle-button") || target.is(".nav-toggle-button span")) {
        if (sidebarIsOpen) {
          if (!body.hasClass("side-cart-closed")) {
            return body.addClass("side-cart-closed").removeClass("side-nav-closed");
          } else {
            return body.addClass("side-nav-closed sidebar-closed");
          }
        } else {
          return body.removeClass("side-nav-closed sidebar-closed");
        }
      } else if (target.is(".cart-count") && theme.isMobileWindow) {
        event.preventDefault();
        if (sidebarIsOpen) {
          if (!body.hasClass("side-nav-closed")) {
            return body.addClass("side-nav-closed").removeClass("side-cart-closed");
          } else {
            return body.addClass("side-cart-closed sidebar-closed");
          }
        } else {
          return body.removeClass("side-cart-closed sidebar-closed");
        }
      }
    };

    return HeaderView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.SidebarView = (function(_super) {
    __extends(SidebarView, _super);

    function SidebarView() {
      return SidebarView.__super__.constructor.apply(this, arguments);
    }

    SidebarView.prototype.initialize = function() {
      this.header = $(".main-header");
      this.navigation = this.$(".navigation");
      this.cartSidebar = this.$(".sidebar.cart");
      return this.navigationView = new Site.NavigationView({
        el: this.navigation
      });
    };

    SidebarView.prototype.pageResize = function() {
      var cartFromHeader, currencySwitch, currentCount, searchFromHeader;
      this.navigationView.checkForMobile();
      this.$el.css("top", this.header.outerHeight() + (theme.adminUI.isExpanded() ? 40 : 0));
      $(document.body).toggleClass("sidebar-can-transition", theme.isMobileWindow);
      if (theme.isMobileWindow && !this.hasHeaderContents) {
        searchFromHeader = $("<li class=\"mobile-search\">\n  " + (this.header.find(".header-search-form")[0].outerHTML) + "\n</li>");
        ;
        currentCount = this.header.find(".drop-cart .item").length;
        if (!currentCount) {
          currentCount = 0;
        }
        cartFromHeader = $("<div class=\"top-group\">").html($("<span class=\"item-count\" />")).append($("<div class=\"cart-value\" />"));
        if (currencySwitch) {
          cartFromHeader.children(".item-count").after(currencySwitch);
        }
        this.navigation.find("ul").first().prepend(searchFromHeader);
        this.cartSidebar.append(cartFromHeader);
        new Site.SearchView({
          el: searchFromHeader.find(".header-search-form")
        });
        new Site.CartSidebarView({
          el: this.cartSidebar
        });
        return this.hasHeaderContents = true;
      }
    };

    return SidebarView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.CartSidebarView = (function(_super) {
    __extends(CartSidebarView, _super);

    function CartSidebarView() {
      return CartSidebarView.__super__.constructor.apply(this, arguments);
    }

    CartSidebarView.prototype.initialize = function() {
      var count, value;
      this.headerCart = $(".main-header .shopping-cart-wrap");
      this.countContainer = this.$(".item-count");
      this.valueContainer = this.$(".cart-value");
      count = this.headerCart.find(".drop-cart .item").length;
      if (!count) {
        count = 0;
      }
      value = this.headerCart.find(".cart-text").text().trim();
      if (value.indexOf("(") !== -1) {
        value = value.substring(0, value.indexOf("("));
      }
      this.countContainer.text("" + count + " " + (count >= 1 ? Theme.cartCountLabels.plural : Theme.cartCountLabels.singular));
      this.valueContainer.text(value);
      if (count !== 0) {
        return this.$el.append(this.headerCart.find(".cart-tools")[0].outerHTML);
      }
    };

    return CartSidebarView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.CurrencyView = (function(_super) {
    __extends(CurrencyView, _super);

    function CurrencyView() {
      return CurrencyView.__super__.constructor.apply(this, arguments);
    }

    CurrencyView.prototype.events = {
      "change [name=currencies]": "convertAll",
      "switch-currency": "switchCurrency",
      "reset-currency": "resetCurrency"
    };

    CurrencyView.prototype.initialize = function() {
      var cents, doubleMoney, money, _i, _j, _len, _len1, _ref, _ref1;
      Currency.format = Theme.currencySwitcherFormat;
      Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
      Currency.money_format[Theme.currency] = Theme.moneyFormat;
      this.defaultCurrency = Theme.defaultCurrency || Theme.currency;
      this.cookieCurrency = Currency.cookie.read();
      if (this.cookieCurrency) {
        this.$("[name=currencies]").val(this.cookieCurrency);
      }
      _ref = $("span.money span.money");
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        doubleMoney = _ref[_i];
        $(doubleMoney).parents("span.money").removeClass("money");
      }
      _ref1 = $("span.money");
      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
        money = _ref1[_j];
        $(money).data("currency-" + Theme.currency, $(money).html());
        if (Currency.format === "money_with_currency_format") {
          cents = parseInt($(money).html().replace(/[^0-9]/g, ""), 10);
          $(money).html(Shopify.formatMoney(cents, Theme.moneyFormat));
        }
      }
      return this.switchCurrency();
    };

    CurrencyView.prototype.resetCurrency = function() {
      return Currency.convertAll(this.defaultCurrency, this.$("[name=currencies]").val());
    };

    CurrencyView.prototype.switchCurrency = function() {
      if (this.cookieCurrency === null) {
        if (Theme.currency === !this.defaultCurrency) {
          return Currency.convertAll(Theme.currency, this.defaultCurrency);
        } else {
          return Currency.currentCurrency = this.defaultCurrency;
        }
      } else if (this.$("[name=currencies]").size() && this.$("[name=currencies] option[value=" + this.cookieCurrency + "]").size() === 0) {
        Currency.currentCurrency = Theme.currency;
        return Currency.cookie.write(Theme.currency);
      } else if (this.cookieCurrency === Theme.currency) {
        return Currency.currentCurrency = Theme.currency;
      } else {
        return Currency.convertAll(Theme.currency, this.cookieCurrency);
      }
    };

    CurrencyView.prototype.convertAll = function(event, variant, selector) {
      var newCurrency;
      newCurrency = $(event.target).val();
      Currency.convertAll(Currency.currentCurrency, newCurrency);
      return this.cookieCurrency = newCurrency;
    };

    return CurrencyView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.NavigationView = (function(_super) {
    __extends(NavigationView, _super);

    function NavigationView() {
      return NavigationView.__super__.constructor.apply(this, arguments);
    }

    NavigationView.prototype.events = {
      "click a": "navigationItemPressed"
    };

    NavigationView.prototype.checkForMobile = function() {
      if (!theme.isMobileWindow) {
        return this.$(".is-parent-menu").css("transform", "none").add(".is-next-menu").removeClass("is-parent-menu is-next-menu");
      }
    };

    NavigationView.prototype.navigationItemPressed = function(event) {
      var currentMenu, parentItem, parentMenu, positionTop, target;
      target = $(event.target);
      if (target.is(".go-backward")) {
        target = target.parent();
      }
      if (target.is(".go-forward")) {
        event.preventDefault();
        parentItem = target.closest("li");
        parentMenu = parentItem.closest("ul").addClass("is-parent-menu");
        positionTop = parentItem.position().top;
        parentItem.find("ul").first().addClass("is-next-menu").css({
          "top": positionTop,
          "display": "block"
        });
        return parentMenu.data("offset", positionTop).css("transform", "translateY(-" + positionTop + "px)").one("trend", function() {
          return parentMenu.css("transform", "translate(-100%, -" + positionTop + "px)");
        });
      } else if (target.closest("li").is(".back-link")) {
        currentMenu = target.closest("ul");
        parentMenu = target.closest(".is-parent-menu");
        return parentMenu.css("transform", "translate(0, -" + (parentMenu.data("offset")) + "px)").one("trend", function() {
          parentMenu.css("transform", "translate(0,0").data("offset", "0").removeClass("is-parent-menu");
          return currentMenu.removeClass("is-next-menu").css({
            "top": "auto",
            "display": "none"
          });
        });
      }
    };

    return NavigationView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.ImageZoomView = (function(_super) {
    __extends(ImageZoomView, _super);

    function ImageZoomView() {
      return ImageZoomView.__super__.constructor.apply(this, arguments);
    }

    ImageZoomView.prototype.events = {
      "prepare-zoom": "prepareZoom",
      "click": "toggleZoom",
      "mouseout .product-zoom": "toggleZoom",
      "mousemove .product-zoom": "zoomImage"
    };

    ImageZoomView.prototype.initialize = function() {
      this.zoomArea = this.$(".product-zoom");
      return this.$el.imagesLoaded((function(_this) {
        return function() {
          return _this.prepareZoom();
        };
      })(this));
    };

    ImageZoomView.prototype.prepareZoom = function() {
      var newImage, photoAreaHeight, photoAreaWidth;
      photoAreaWidth = this.$el.width();
      photoAreaHeight = this.$el.height();
      newImage = new Image();
      $(newImage).on("load", (function(_this) {
        return function() {
          var ratio, ratios;
          _this.zoomImageWidth = newImage.width;
          _this.zoomImageHeight = newImage.height;
          ratios = new Array();
          ratios[0] = _this.zoomImageWidth / photoAreaWidth;
          ratios[1] = _this.zoomImageHeight / photoAreaHeight;
          ratio = Math.max.apply(Math, ratios);
          if (ratio < 1.4) {
            _this.$el.removeClass("zoom-enabled");
          } else {
            _this.$el.addClass("zoom-enabled");
            return _this.zoomArea.css({
              backgroundImage: "url(" + newImage.src + ")"
            });
          }
        };
      })(this));
      return newImage.src = this.$("img").attr("src");
    };

    ImageZoomView.prototype.toggleZoom = function(event) {
      if (this.$el.hasClass("zoom-enabled")) {
        if (event.type === "mouseout") {
          this.zoomArea.removeClass("active");
          return;
        }
        if (this.zoomArea.hasClass("active")) {
          this.zoomArea.removeClass("active");
        } else {
          this.zoomArea.addClass("active");
        }
        return this.zoomImage(event);
      }
    };

    ImageZoomView.prototype.zoomImage = function(event) {
      var bigImageOffset, bigImageX, bigImageY, mousePositionX, mousePositionY, newBackgroundPosition, ratioX, ratioY, zoomHeight, zoomWidth;
      zoomWidth = this.zoomArea.width();
      zoomHeight = this.zoomArea.height();
      bigImageOffset = this.$el.offset();
      bigImageX = Math.round(bigImageOffset.left);
      bigImageY = Math.round(bigImageOffset.top);
      mousePositionX = event.pageX - bigImageX;
      mousePositionY = event.pageY - bigImageY;
      if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
        if (this.zoomArea.hasClass("active")) {
          ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
          ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;
          if (ratioX > 0) {
            ratioX = 0;
          }
          if (ratioY > 0) {
            ratioY = 0;
          }
          if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
            ratioX = -(this.zoomImageWidth - zoomWidth);
          }
          if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
            ratioY = -(this.zoomImageHeight - zoomHeight);
          }
          newBackgroundPosition = "" + ratioX + "px " + ratioY + "px";
          return this.zoomArea.css({
            backgroundPosition: newBackgroundPosition
          });
        }
      }
    };

    return ImageZoomView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.AccountView = (function(_super) {
    __extends(AccountView, _super);

    function AccountView() {
      return AccountView.__super__.constructor.apply(this, arguments);
    }

    AccountView.prototype.events = {
      "click .delete-address": "deleteAddress",
      "click .edit-address, .cancel-edit": "toggleEditAddress",
      "click .toggle-new-address": "toggleNewAddress",
      "click .toggle-forgetfulness span": "recoverPassword"
    };

    AccountView.prototype.initialize = function() {
      if ($(document.body).hasClass("template-customers-addresses")) {
        this.prepareAddresses();
      }
      if ($(document.body).hasClass("template-customers-login")) {
        this.checkForReset();
      }
      if (window.location.hash === "#recover") {
        return this.recoverPassword();
      }
    };

    AccountView.prototype.recoverPassword = function() {
      return this.$(".customer-login, .recover-password").toggleClass("hidden");
    };

    AccountView.prototype.checkForReset = function() {
      if ($(".reset-check").data("successful-reset") === true) {
        return $(".successful-reset").show();
      }
    };

    AccountView.prototype.prepareAddresses = function() {
      var address, addressID, addresses, _i, _len, _results;
      new Shopify.CountryProvinceSelector("address-country", "address-province", {
        hideElement: "address-province-container"
      });
      addresses = this.$(".customer-address");
      if (addresses.length) {
        _results = [];
        for (_i = 0, _len = addresses.length; _i < _len; _i++) {
          address = addresses[_i];
          addressID = $(address).data("address-id");
          _results.push(new Shopify.CountryProvinceSelector("address-country-" + addressID, "address-province-" + addressID, {
            hideElement: "address-province-container-" + addressID
          }));
        }
        return _results;
      }
    };

    AccountView.prototype.deleteAddress = function(event) {
      var addressID;
      addressID = $(event.target).parents("[data-address-id]").data("address-id");
      return Shopify.CustomerAddress.destroy(addressID);
    };

    AccountView.prototype.toggleEditAddress = function(event) {
      var addressID, form;
      addressID = $(event.target).parents("[data-address-id]").data("address-id");
      form = $(".customer-address-edit-form[data-address-id='" + addressID + "']");
      return form.add(form.siblings(".customer-address")).toggleClass("hidden");
    };

    AccountView.prototype.toggleNewAddress = function() {
      return this.$(".add-new-address-container, .customer-new-address, .customer-addresses").toggleClass("hidden");
    };

    return AccountView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.CartView = (function(_super) {
    __extends(CartView, _super);

    function CartView() {
      return CartView.__super__.constructor.apply(this, arguments);
    }

    CartView.prototype.events = {
      "click .get-rates": "calculateShipping",
      "change .quantity input": "updateQuantity",
      "click .remove span": "removeProduct",
      "click .cart-undo": "undoRemoval",
      "change .cart-instructions textarea": "saveSpecialInstructions"
    };

    CartView.prototype.initialize = function() {
      this.savedProducts = [];
      if (Theme.shippingCalculator) {
        this.shippingCalculator();
      }
      if (Theme.shippingCalculator && Theme.customerLoggedIn && Theme.customerCountry.length) {
        this.calculateShipping();
      }
      return Shopify.onError = (function(_this) {
        return function(XMLHttpRequest) {
          return _this.handleErrors(XMLHttpRequest);
        };
      })(this);
    };

    CartView.prototype.saveSpecialInstructions = function() {
      var newNote;
      newNote = $(".cart-instructions textarea").val();
      return Shopify.updateCartNote(newNote, function(cart) {});
    };

    CartView.prototype.updateQuantity = function(event) {
      var newQuantity, productPrice, productRow, variant;
      productRow = $(event.target).parents("tr");
      productPrice = productRow.find("td.total");
      variant = productRow.data("variant");
      newQuantity = $(event.target).val();
      if (newQuantity === "0") {
        this.removeProduct(null, variant);
        return;
      }
      return Shopify.changeItem(variant, newQuantity, (function(_this) {
        return function(cart) {
          var item, newProductPrice, _i, _len, _ref;
          _ref = cart.items;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            item = _ref[_i];
            if (item.id === variant) {
              newProductPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
              productPrice.text(newProductPrice);
            }
          }
          return _this.updateCart(cart);
        };
      })(this));
    };

    CartView.prototype.removeProduct = function(event, variant) {
      var itemRemoved, itemRow, itemRowContents, productTitle, productURL, undo;
      if (variant) {
        itemRow = $(".variant-" + variant);
      } else {
        variant = $(event.target).parents("tr").data("variant");
        itemRow = $(event.target).parents("tr");
      }
      itemRowContents = itemRow.find("td");
      productTitle = itemRow.data("title");
      productURL = itemRow.data("url");
      this.savedProducts[variant] = {
        "id": variant,
        "content": itemRowContents,
        "quantity": itemRow.find("td.quantity input").val()
      };
      itemRemoved = Theme.itemRemovedFromCart.replace("{{ item_title }}", "<a href='" + productURL + "'>" + productTitle + "</a>");
      undo = "<span class='cart-undo' data-variant='" + variant + "'>" + Theme.itemRemovedFromCartUndo + "</span>";
      return Shopify.removeItem(variant, (function(_this) {
        return function(cart) {
          itemRow.addClass("removing").one("trend", function() {
            itemRow.html("<td colspan='5'>" + itemRemoved + " " + undo + "</td>");
            return itemRow.removeClass("removing");
          });
          return _this.updateCart(cart);
        };
      })(this));
    };

    CartView.prototype.undoRemoval = function(event) {
      var savedProduct, variant;
      variant = $(event.target).data("variant");
      savedProduct = this.savedProducts[variant];
      $("tr.variant-" + variant).html(savedProduct.content);
      return Shopify.addItem(variant, savedProduct.quantity, (function(_this) {
        return function() {
          return Shopify.getCart(function(cart) {
            return _this.updateCart(cart);
          });
        };
      })(this));
    };

    CartView.prototype.updateCart = function(cart) {
      var cartCount, cartCountText, newTotal;
      newTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
      $(".cart-totals .cart-price").text(newTotal);
      cartCount = cart.item_count;
      cartCountText = cart.item_count === 1 ? "item" : "items";
      return $(".cart-count").text("" + cartCount + " " + cartCountText);
    };

    CartView.prototype.updateShippingLabel = function(select) {
      var selectedVariant;
      if (select) {
        select = $(select);
        selectedVariant = select.find("option:selected").val();
        return select.prev(".selected-option").text(selectedVariant);
      }
    };

    CartView.prototype.shippingCalculator = function() {
      var selectableOptions;
      Shopify.Cart.ShippingCalculator.show({
        submitButton: Theme.shippingButton,
        submitButtonDisabled: Theme.shippingDisabled,
        customerIsLoggedIn: Theme.customerLoggedIn,
        moneyFormat: Theme.moneyFormat
      });
      selectableOptions = this.$(".cart-shipping-calculator select");
      setTimeout((function(_this) {
        return function() {
          var select, _i, _len, _results;
          _results = [];
          for (_i = 0, _len = selectableOptions.length; _i < _len; _i++) {
            select = selectableOptions[_i];
            _results.push(_this.updateShippingLabel(select));
          }
          return _results;
        };
      })(this), 500);
      return this.$(".cart-shipping-calculator select").change((function(_this) {
        return function() {
          var select, _i, _len, _results;
          _results = [];
          for (_i = 0, _len = selectableOptions.length; _i < _len; _i++) {
            select = selectableOptions[_i];
            _results.push(_this.updateShippingLabel(select));
          }
          return _results;
        };
      })(this));
    };

    CartView.prototype.calculateShipping = function() {
      var shippingAddress;
      this.$(".get-rates").val(Theme.shippingDisabled);
      shippingAddress = {};
      shippingAddress.zip = this.$(".address-zip").val() || "";
      shippingAddress.country = this.$(".address-country").val() || "";
      shippingAddress.province = this.$(".address-province").val() || "";
      return Shopify.getCartShippingRatesForDestination(shippingAddress, function() {
        var address, firstRate, price, rate, rateValues, ratesFeedback, response, shippingCalculatorResponse, _i, _len;
        address = "" + shippingAddress.zip + ", " + shippingAddress.province + ", " + shippingAddress.country;
        if (!shippingAddress.province.length) {
          address = "" + shippingAddress.zip + ", " + shippingAddress.country;
        }
        if (!shippingAddress.zip.length) {
          address = "" + shippingAddress.province + ", " + shippingAddress.country;
        }
        if (!(shippingAddress.province.length && shippingAddress.zip.length)) {
          address = shippingAddress.country;
        }
        shippingCalculatorResponse = this.$(".cart-shipping-calculator-response");
        shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
        ratesFeedback = $(".shipping-calculator-response");
        if (rates.length > 1) {
          firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
          Theme.shippingCalcMultiRates = Theme.shippingCalcMultiRates.replace("{{ address }}", address).replace("{{ number_of_rates }}", rates.length).replace("{{ rate }}", "<span class='money'>" + firstRate + "</span>");
          ratesFeedback.html(Theme.shippingCalcMultiRates);
        } else if (rates.length === 1) {
          response = Theme.shippingCalcOneRate.replace("{{ address }}", address);
          ratesFeedback.html(response);
        } else {
          ratesFeedback.html(Theme.shippingCalcNoRates);
        }
        for (_i = 0, _len = rates.length; _i < _len; _i++) {
          rate = rates[_i];
          price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          rateValues = Theme.shippingCalcRateValues.replace("{{ rate_title }}", rate.name).replace("{{ rate }}", "<span class='money'>" + price + "</span>");
          this.$(".shipping-rates").append("<li>" + rateValues + "</li>");
        }
        return this.$(".get-rates").val(Theme.shippingButton);
      });
    };

    CartView.prototype.handleErrors = function(errors) {
      var errorMessage;
      errorMessage = $.parseJSON(errors.responseText);
      errorMessage = Theme.shippingCalcErrorMessage.replace("{{ error_message }}", errorMessage.zip);
      this.$(".cart-shipping-calculator-response").html("<p>" + errorMessage + "</p>");
      return this.$(".get-rates").val(Theme.shippingButton);
    };

    return CartView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.CollectionView = (function(_super) {
    __extends(CollectionView, _super);

    function CollectionView() {
      return CollectionView.__super__.constructor.apply(this, arguments);
    }

    CollectionView.prototype.events = {
      "change .collection-sorting select": "sortProducts",
      "change .collection-tag-filter input": "filterByTag"
    };

    CollectionView.prototype.initialize = function() {
      var collectionList, filterChecksSetup, sidebar;
      sidebar = $(".main-sidebar");
      collectionList = this.$(".collection-list");
      filterChecksSetup = false;
      $(window).on("resize", (function(_this) {
        return function() {
          var fullDesktop;
          fullDesktop = document.documentElement.offsetWidth >= 940;
          if (fullDesktop) {
            _this.filterPanel = collectionList.find(".collection-viewing-parameters");
            _this.filterPanel.prependTo(sidebar);
          } else {
            _this.filterPanel = sidebar.find(".collection-viewing-parameters");
            if (!_this.filterPanel.length) {
              _this.filterPanel = collectionList.find(".collection-viewing-parameters");
            }
            _this.filterPanel.prependTo(collectionList);
          }
          if (!filterChecksSetup) {
            _this.setupFilterChecks();
            return filterChecksSetup = true;
          }
        };
      })(this));
      return $(document.body).on("click", ".collection-viewing-parameters h3", (function(_this) {
        return function() {
          return _this.toggleFilterPanel();
        };
      })(this));
    };

    ;

    CollectionView.prototype.setupFilterChecks = function() {
      var count, _results;
      this.filterCheckboxes = this.filterPanel.find(".collection-tag-filter input");
      this.checkedFilterBoxes = this.filterCheckboxes.filter(":checked");
      this.checkedFilterTags = [];
      count = 0;
      _results = [];
      while (count < this.checkedFilterBoxes.length) {
        this.checkedFilterTags.push($(this.checkedFilterBoxes[count]).data("handle"));
        _results.push(count = count + 1);
      }
      return _results;
    };

    CollectionView.prototype.toggleFilterPanel = function() {
      return this.filterPanel.toggleClass("active");
    };

    CollectionView.prototype.sortProducts = function(event) {
      var Sorting, currentSearch, index, part, search, searchParts, _i, _len;
      Sorting = {};
      Sorting.sort_by = this.$(".collection-sorting select").val();
      if ($(event.target).closest(".collection-sorting").hasClass("vendor-collection")) {
        currentSearch = location.search;
        searchParts = currentSearch.split("&");
        for (index = _i = 0, _len = searchParts.length; _i < _len; index = ++_i) {
          part = searchParts[index];
          if (part.indexOf("sort_by") !== -1) {
            searchParts.splice(index, 1);
          }
        }
        search = searchParts.join("&");
        return location.search = "" + search + "&" + (jQuery.param(Sorting));
      } else {
        return location.search = jQuery.param(Sorting);
      }
    };

    CollectionView.prototype.filterByTag = function(event) {
      var tag, target, url;
      target = $(event.target);
      url = this.filterPanel.data("url");
      tag = target.data("handle");
      if (target.is(":checked")) {
        this.checkedFilterTags.push(tag);
      } else {
        this.checkedFilterTags.splice(this.checkedFilterTags.indexOf(tag));
      }
      return window.location.href = "/collections/" + (this.filterPanel.data("url")) + "/" + (this.checkedFilterTags.join("+"));
    };

    ;

    return CollectionView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.HomeView = (function(_super) {
    __extends(HomeView, _super);

    function HomeView() {
      return HomeView.__super__.constructor.apply(this, arguments);
    }

    HomeView.prototype.initialize = function() {
      if (Theme.slideshow) {
        new Site.SlideshowView({
          el: this.$(".home-slideshow")
        });
      }
      if (Theme.instagram) {
        new Site.InstagramView({
          el: this.$(".instagram-widget")
        });
      }
      if (Theme.twitter) {
        new Site.TwitterView({
          el: this.$(".twitter-widget")
        });
      }
      this.featuredBlogPosts = this.$(".featured-blog");
      if (this.featuredBlogPosts.length) {
        return this.setupfeaturedBlogPosts();
      }
    };

    HomeView.prototype.setupfeaturedBlogPosts = function() {
      var post, _i, _len, _ref, _results;
      _ref = this.featuredBlogPosts.find(".featured-blog-post");
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        post = _ref[_i];
        post = $(post);
        _results.push(post.addClass(post.is(":odd") ? "odd" : "even"));
      }
      return _results;
    };

    return HomeView;

  })(Backbone.View);

}).call(this);

(function() {
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.ProductView = (function(_super) {
    __extends(ProductView, _super);

    function ProductView() {
      this.selectCallback = __bind(this.selectCallback, this);
      return ProductView.__super__.constructor.apply(this, arguments);
    }

    ProductView.prototype.events = {
      "change .single-option-selector": "associateImageVariant",
      "mouseenter .pager": "adjustSlideshowThumb",
      "click .slideshow-slide": "toggleZoom",
      "mousemove .product-slideshow": "panZoom",
      "click .pager": "changeSlide",
      "click .previous": "previousSlide",
      "click .next": "nextSlide"
    };

    ProductView.prototype.initialize = function() {
      this.productId = this.$(".product-wrap").data("product-id");
      this.product = Theme.product;
      this.variants = this.product.variants;
      this.images = this.product.images;
      this.minimumPriceArea = this.$(".price-minimum");
      this.cacheImages();
      if (this.$(".product-variants").length) {
        this.setupSelectors();
      }
      return this.setupSlideshow();
    };

    ProductView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, _i, _len, _ref;
      _ref = this.minimumPriceArea[0].attributes;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        attribute = _ref[_i];
        if (attribute.name.indexOf("data-") > -1) {
          this.minimumPriceArea.attr(attribute.name, "");
        }
      }
      this.minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    ProductView.prototype.cacheImages = function() {
      return Shopify.Image.preload(this.images, "1024x1024");
    };

    ProductView.prototype.setupSelectors = function() {
      var optionSelectors, variant, _i, _len, _ref;
      optionSelectors = new Shopify.OptionSelectors("product-variants-" + this.productId, {
        product: this.product,
        onVariantSelected: this.selectCallback,
        enableHistoryState: true
      });
      optionSelectors.selectVariant(Theme.firstVariant);
      _ref = this.variants;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        variant = _ref[_i];
        if (variant.featured_image) {
          this.hasVariantImages = true;
          return;
        }
      }
    };

    ProductView.prototype.selectCallback = function(variant, selector) {
      var addToCartButton, newImage, originalImage;
      addToCartButton = this.$(".add-to-cart input");
      if (variant) {
        if (variant.available) {
          addToCartButton.val(Theme.addToCartText).removeClass("disabled").prop("disabled", false);
        } else {
          addToCartButton.val(Theme.soldOutText).addClass("disabled").prop("disabled", true);
        }
        this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          this.minimumPriceArea.after("<span class='price-compare money' />");
          this.$(".price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          this.switchCurrency(variant.price, variant.compare_at_price);
        }
        if (this.hasVariantImages) {
          if (variant.featured_image) {
            originalImage = this.$(".product-main-image img");
            newImage = variant.featured_image;
            return Shopify.Image.switchImage(newImage, originalImage[0]);
          } else {
            return this.$(".product-main-image img").attr("src", this.product.featured_image);
          }
        }
      } else {
        return addToCartButton.val(Theme.unavailableText).addClass("disabled").prop("disabled", true);
      }
    };

    ProductView.prototype.toggleZoom = function(event) {
      var target;
      target = $(event.target);
      if (target.is(".slide-navigation, .pager, [data-high-res]") || target.closest(".pager").length) {
        return;
      }
      this.currentSlide.add(document.body).toggleClass("zoom-active");
      this.zoomActive = !this.zoomActive;
      if (!this.zoomActive) {
        return this.currentImage.css({
          "transform": "translate(0,0)",
          "top": 0,
          "left": 0
        });
      }
    };

    ProductView.prototype.disableZoom = function() {
      this.currentSlide.add(document.body).removeClass("zoom-active");
      this.currentImage.css({
        "transform": "translate(0,0)",
        "top": 0,
        "left": 0
      });
      return this.zoomActive = false;
    };

    ProductView.prototype.panZoom = function(event) {
      var offset, position;
      if (!this.zoomActive) {
        return;
      }
      position = {
        x: event.pageX - this.slideshowSpec.containerLeft,
        y: event.pageY - this.slideshowSpec.containerTop
      };
      offset = {
        x: position.x * this.slideshowSpec.widthFactor,
        y: position.y * this.slideshowSpec.heightFactor
      };
      if (theme.ltIE9) {
        return this.currentSlide.css({
          "position": "relative",
          "top": "-" + (offset.x * this.slideshowSpec.widthFactor) + "px",
          "left": "-" + (offset.y * this.slideshowSpec.heightFactor) + "px"
        });
      } else {
        return this.currentImage.css({
          "transform": "translate(-" + (offset.x * this.slideshowSpec.widthFactor) + "px,-" + (offset.y * this.slideshowSpec.heightFactor) + "px)"
        });
      }
    };

    ProductView.prototype.setupSlideshow = function() {
      this.slideshow = this.$(".product-slideshow");
      this.slideshowPagers = this.slideshow.find(".pager");
      this.zoomActive = false;
      this.slideshow.flickity({
        cellSelector: ".slideshow-slide",
        accessibility: true,
        imagesLoaded: true,
        wrapAround: true,
        autoPlay: false,
        draggable: false,
        percentPosition: true,
        pageDots: false,
        prevNextButtons: false
      }).on("cellSelect", (function(_this) {
        return function() {
          return _this.slideSettled();
        };
      })(this));
      this.flickityData = this.slideshow.data("flickity");
      this.slideshowSlides = this.slideshow.find(".flickity-slider").children();
      this.slideSettled();
      return $(window).on("resize", (function(_this) {
        return function() {
          return _this.setSlideshowSpec();
        };
      })(this));
    };

    ProductView.prototype.slideSettled = function() {
      this.currentSlide = $(this.slideshowSlides[this.flickityData.selectedIndex]);
      this.currentImage = this.currentSlide.find("img");
      this.slideshow.height(this.currentSlide.height());
      return this.setSlideshowSpec();
    };

    ProductView.prototype.setSlideshowSpec = function() {
      var containerOffset, currentImage;
      containerOffset = this.slideshow.offset();
      currentImage = new Image();
      currentImage.src = this.currentImage.attr("src");
      return this.slideshowSpec = {
        containerTop: containerOffset.top,
        containerLeft: containerOffset.left,
        widthFactor: this.slideshow.width() / currentImage.width,
        heightFactor: this.slideshow.height() / currentImage.height
      };
    };

    ProductView.prototype.nextSlide = function() {
      this.disableZoom();
      return this.slideshow.flickity("next", true);
    };

    ProductView.prototype.previousSlide = function() {
      this.disableZoom();
      return this.slideshow.flickity("previous", true);
    };

    ProductView.prototype.changeSlide = function(event) {
      var target;
      target = $(event.target);
      this.disableZoom();
      return this.slideshow.flickity("select", target.index());
    };

    ProductView.prototype.adjustSlideshowThumb = function(event) {
      var target, thumbnail;
      target = $(event.target);
      thumbnail = target.children("img");
      return thumbnail.css("margin-left", -(thumbnail.width() / 2));
    };

    return ProductView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.SlideshowView = (function(_super) {
    __extends(SlideshowView, _super);

    function SlideshowView() {
      return SlideshowView.__super__.constructor.apply(this, arguments);
    }

    SlideshowView.prototype.events = {
      "click .next-slide": "goNextSlide",
      "click .previous-slide": "goPreviousSlide"
    };

    SlideshowView.prototype.initialize = function() {
      var autoPlay;
      this.controls = this.$(".slideshow-navigation");
      autoPlay = false;
      if (this.$el.data("autoplay") === true && this.$el.data("delay")) {
        autoPlay = this.$el.data("delay") * 1000;
      }
      this.slideshow = this.$(".slideshow-slides").flickity({
        accessibility: true,
        imagesLoaded: true,
        wrapAround: true,
        autoPlay: autoPlay,
        draggable: true,
        percentPosition: true,
        pageDots: false,
        prevNextButtons: false
      }).on("cellSelect", (function(_this) {
        return function() {
          return _this.adjustSlide();
        };
      })(this));
      this.flickityData = this.slideshow.data("flickity");
      this.slideshowSlides = this.slideshow.find(".flickity-slider").children();
      this.adjustSlide();
      return $(window).on("resize", (function(_this) {
        return function() {
          return _this.adjustSlide();
        };
      })(this));
    };

    SlideshowView.prototype.adjustSlide = function() {
      var slide, slideContent, textColor;
      slide = $(this.slideshowSlides[this.flickityData.selectedIndex]);
      slideContent = slide.children(".slide-content");
      textColor = /text-dark|text-light/.exec(slide.attr("class"))[0];
      slideContent.css({
        marginTop: -slideContent.outerHeight() / 2,
        marginLeft: -slideContent.outerWidth() / 2
      });
      return this.controls.attr("data-color", textColor);
    };

    SlideshowView.prototype.goNextSlide = function() {
      return this.slideshow.flickity("next", true);
    };

    SlideshowView.prototype.goPreviousSlide = function() {
      return this.slideshow.flickity("previous", true);
    };

    return SlideshowView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.InstagramView = (function(_super) {
    __extends(InstagramView, _super);

    function InstagramView() {
      return InstagramView.__super__.constructor.apply(this, arguments);
    }

    InstagramView.prototype.initialize = function() {
      var url;
      this.photoContainer = this.$(".instagram-photos");
      this.layoutType = this.$el.hasClass("layout-two") ? 2 : 1;
      this.layoutCount = this.layoutType === 1 ? 5 : 8;
      if (Theme.instagramShowTag && Theme.instagramTag.length) {
        url = "https://api.instagram.com/v1/tags/" + Theme.instagramTag + "/media/recent?access_token=" + Theme.instagramAccessToken + "&count=" + this.layoutCount + "&callback=";
      } else {
        url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + Theme.instagramAccessToken + "&count=" + this.layoutCount + "&callback=";
      }
      return $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: url,
        success: (function(_this) {
          return function(response) {
            var photo, _i, _len, _ref, _results;
            if (response.meta.code === 200) {
              _ref = response.data;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                photo = _ref[_i];
                photo = $("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>");
                if (_i % 2 && theme.ltIE9 && _this.layoutType === 2) {
                  photo.addClass("odd");
                }
                _results.push(_this.photoContainer.append(photo));
              }
              return _results;
            } else {
              _this.$el.remove();
              return console.log("Instagram error: " + response.meta.error_message);
            }
          };
        })(this),
        error: (function(_this) {
          return function(response) {
            _this.$el.remove();
            return console.log("Instagram error: " + response.meta.error_message);
          };
        })(this)
      });
    };

    return InstagramView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.TwitterView = (function(_super) {
    __extends(TwitterView, _super);

    function TwitterView() {
      return TwitterView.__super__.constructor.apply(this, arguments);
    }

    TwitterView.prototype.initialize = function() {
      return twitterFetcher.fetch({
        "id": Theme.twitterId,
        "maxTweets": 1,
        "enableLinks": true,
        "showUser": true,
        "showTime": true,
        "showRetweet": Theme.twitterShowRetweets,
        "customCallback": this.renderTweets,
        "showInteraction": true
      });
    };

    TwitterView.prototype.renderTweets = function(tweets) {
      var tweet, _i, _len;
      if (tweets.length) {
        for (_i = 0, _len = tweets.length; _i < _len; _i++) {
          tweet = tweets[_i];
          return this.$(".twitter-tweet").append($(tweet));
        }
      }
      $(".twitter-widget").remove();
      return console.error("No tweets to display. Most probable cause is an incorrectly entered Widget ID.");
    };

    return TwitterView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.RTEView = (function(_super) {
    __extends(RTEView, _super);

    function RTEView() {
      return RTEView.__super__.constructor.apply(this, arguments);
    }

    RTEView.prototype.events = {
      "click .tabs li": "switchTabs"
    };

    RTEView.prototype.initialize = function() {
      this.setupTabs();
      return this.setupTables();
    };

    RTEView.prototype.setupTabs = function() {
      var tabsContainer;
      tabsContainer = this.$el.find(".tabs");
      this.tabs = tabsContainer.find("ul li");
      this.panels = tabsContainer.children("div");
      return this.currentTabs = this.tabs.filter(":first").add(this.panels.filter(":first")).addClass("active");
    };

    RTEView.prototype.switchTabs = function(event) {
      var index;
      index = $(event.currentTarget).index();
      this.currentTabs.removeClass("active");
      return this.currentTabs = this.tabs.eq(index).add(this.panels.eq(index)).addClass("active");
    };

    RTEView.prototype.setupTables = function() {
      var table, _i, _len, _ref, _results;
      _ref = this.$el.find("table");
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        table = _ref[_i];
        _results.push($(table).wrap($("<div class='table-wrapper' />")));
      }
      return _results;
    };

    return RTEView;

  })(Backbone.View);

}).call(this);

(function() {
  var __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.SelectView = (function(_super) {
    __extends(SelectView, _super);

    function SelectView() {
      return SelectView.__super__.constructor.apply(this, arguments);
    }

    SelectView.prototype.events = {
      "change": "updateSelectText"
    };

    SelectView.prototype.initialize = function() {
      if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
        this.$el.wrap("<div class='select-wrapper' />").parent().prepend("<span class='selected-text'></span>");
      }
      return this.updateSelectText();
    };

    SelectView.prototype.updateSelectText = function(event) {
      var newOption;
      newOption = this.$el.find("option:selected").text();
      return this.$el.siblings(".selected-text").text(newOption);
    };

    return SelectView;

  })(Backbone.View);

}).call(this);

(function() {
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  Site.QuickShopView = (function(_super) {
    __extends(QuickShopView, _super);

    function QuickShopView() {
      this.selectCallback = __bind(this.selectCallback, this);
      return QuickShopView.__super__.constructor.apply(this, arguments);
    }

    QuickShopView.prototype.events = {
      "click .product-list-item-thumbnail a": "openQuickShop",
      "click .close-modal": "closeQuickShop",
      "click .slideshow-thumbnails .thumbnail": "switchSlide"
    };

    QuickShopView.prototype.initialize = function() {
      this.open = false;
      this.productID = this.$el.find(".quick-shop-modal").data("product-id");
      this.product = Theme.products[this.productID];
      this.modal = this.$(".quick-shop-modal-wrapper");
      this.addToCartButton = this.$(".add-to-cart input");
      this.minimumPriceArea = this.$(".price-minimum");
      this.setupSlideshow();
      this.setupSelectors();
      return $(document.body).on("keyup", (function(_this) {
        return function(event) {
          if (event.keyCode === 27 && !_this.open) {
            return _this.closeQuickShop();
          }
        };
      })(this));
    };

    QuickShopView.prototype.switchCurrency = function(minimum, compare) {
      var attribute, _i, _len, _ref;
      _ref = this.minimumPriceArea[0].attributes;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        attribute = _ref[_i];
        if (attribute.name.indexOf("data-") > -1) {
          this.minimumPriceArea.attr(attribute.name, "");
        }
      }
      this.minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      this.$(".price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
      return $(".currency-switcher").trigger("reset-currency");
    };

    QuickShopView.prototype.setupSelectors = function() {
      var optionSelectors;
      optionSelectors = new Shopify.OptionSelectors("product-variants-" + this.productID, {
        product: this.product,
        onVariantSelected: this.selectCallback
      });
      return optionSelectors.selectVariant(this.$el.find(".quick-shop-modal").data("variant-id"));
    };

    QuickShopView.prototype.selectCallback = function(variant, selector) {
      if (variant) {
        if (variant.available) {
          this.addToCartButton.val(Theme.addToCartText).removeClass("disabled").prop("disabled", false);
        } else {
          this.addToCartButton.val(Theme.soldOutText).addClass("disabled").prop("disabled", true);
        }
        this.minimumPriceArea.html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        this.$(".price-compare").remove();
        if (variant.compare_at_price > variant.price) {
          this.minimumPriceArea.after("<span class='price-compare money' />");
          this.$(".price-compare").html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat));
        }
        if (Theme.currencySwitcher) {
          return this.switchCurrency(variant.price, variant.compare_at_price);
        }
      } else {
        return this.addToCartButton.val(Theme.unavailableText).addClass("disabled").prop("disabled", true);
      }
    };

    QuickShopView.prototype.openQuickShop = function(event) {
      event.preventDefault();
      this.modal.add(document.body).addClass("quick-shop-open");
      return this.open = true;
    };

    QuickShopView.prototype.closeQuickShop = function() {
      this.modal.add(document.body).removeClass("quick-shop-open");
      return this.open = false;
    };

    QuickShopView.prototype.setupSlideshow = function() {
      this.slideshow = this.$(".large-images");
      this.slideshow.flickity({
        imagesLoaded: true,
        wrapAround: false,
        draggable: false,
        percentPosition: true,
        pageDots: false,
        prevNextButtons: false
      }).on("cellSelect", (function(_this) {
        return function() {
          return _this.slideSettled();
        };
      })(this));
      this.flickityData = this.slideshow.data("flickity");
      this.slideshowSlides = this.slideshow.find(".flickity-slider").children();
      this.slideshowThumbs = this.$(".slideshow-thumbnails .thumbnail");
      return this.slideSettled();
    };

    QuickShopView.prototype.slideSettled = function() {
      this.currentSlide = $(this.slideshowSlides[this.flickityData.selectedIndex]);
      return this.slideshow.height(this.currentSlide.height());
    };

    QuickShopView.prototype.switchSlide = function(event) {
      var target;
      this.slideshowThumbs.removeClass("selected");
      target = $(event.target).addClass("selected");
      return this.slideshow.flickity("select", target.index());
    };

    return QuickShopView;

  })(Backbone.View);

}).call(this);

(function() {
  $(function() {
    window.theme = new Site.ThemeView();
    return theme.render();
  });

}).call(this);
